// src/pages/yachts/special-offers/components/TiersEditor.js
import React from 'react';
import { Field } from 'redux-form';
import { Row, Col, Button, FormGroup } from 'reactstrap';

import RenderField from '../../../../common/components/RenderField';
import { CURRENCIES } from '../validate';

// Free text here silently produces a tier no rate currency can ever match.
const renderCurrencySelect = ({ input, meta }) => (
    <FormGroup className="so-select-group">
        <select className="form-control" {...input}>
            <option value="">Currency</option>
            {CURRENCIES.map((c) => (
                <option key={c} value={c}>
                    {c.toUpperCase()}
                </option>
            ))}
        </select>
        {meta.touched && meta.error && <div className="text-danger">{meta.error}</div>}
    </FormGroup>
);

const TiersEditor = ({ fields, offerType, meta: { error } }) => (
    <div>
        {fields.length === 0 && (
            <p>
                <em>No tiers yet.</em>
            </p>
        )}
        {fields.map((tier, index) => (
            <Row key={index} className="align-items-end">
                <Col xs="3">
                    <Field
                        name={`${tier}.min_duration_days`}
                        type="number"
                        placeholder="Min days"
                        group={`${tier}-min`}
                        component={RenderField}
                    />
                </Col>
                <Col xs="3">
                    <Field
                        name={`${tier}.max_duration_days`}
                        type="number"
                        placeholder="Max days (blank = open)"
                        group={`${tier}-max`}
                        component={RenderField}
                    />
                </Col>
                {offerType === 'tiered_discount' && (
                    <Col xs="3">
                        <Field
                            name={`${tier}.discount_percent`}
                            type="number"
                            placeholder="Discount %"
                            group={`${tier}-pct`}
                            component={RenderField}
                        />
                    </Col>
                )}
                {offerType === 'package' && (
                    <>
                        <Col xs="2">
                            <Field
                                name={`${tier}.package_price`}
                                type="number"
                                placeholder="Package price"
                                group={`${tier}-price`}
                                component={RenderField}
                            />
                        </Col>
                        <Col xs="2">
                            <Field
                                name={`${tier}.package_currency`}
                                component={renderCurrencySelect}
                            />
                        </Col>
                    </>
                )}
                <Col xs="2">
                    <Button
                        color="danger"
                        size="sm"
                        onClick={() => fields.remove(index)}
                    >
                        Remove
                    </Button>
                </Col>
            </Row>
        ))}
        <Button
            color="secondary"
            size="sm"
            type="button"
            onClick={() => fields.push({})}
        >
            + Add tier
        </Button>
        {error && <div className="text-danger">{error}</div>}
    </div>
);

export default TiersEditor;
